/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../../../../services/axios'
import Home from '../../../../assets/icons/alert.svg'
import valid from '../../../../assets/icons/warn.svg'
import itens from '../../../../assets/icons/check.svg'
import check from '../../../../assets/icons/check-green.svg'
import { ContentHeader, MainHeader } from './styles'
import { FaFileCircleCheck } from 'react-icons/fa6'
import { IoCloseCircle } from 'react-icons/io5'
import { IoWarning } from 'react-icons/io5'
import { MdOutlinePendingActions } from 'react-icons/md'
import { useMonthFilter } from '../../../../context/FiltersContext/MonthFilter'
import { carregarDistribuidores } from '../../../../services/dists'

function toLocalDate(dateLike: string | number | Date | null | undefined): Date | null {
  if (dateLike == null) return null
  if (dateLike instanceof Date) {
    return new Date(dateLike.getFullYear(), dateLike.getMonth(), dateLike.getDate())
  }
  if (typeof dateLike === 'number') {
    const dt = new Date(dateLike)
    if (isNaN(dt.getTime())) return null
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate())
  }
  const s = String(dateLike).trim()
  if (!s) return null

  // 1. Formato YYYYMMDD ou DDMMAAAA (8 dígitos sem separador)
  const m8 = s.match(/^(\d{4})(\d{2})(\d{2})$/)
  if (m8) {
    const p1 = Number(m8[1])
    const p2 = Number(m8[2])
    const p3 = Number(m8[3])
    if (p1 >= 1900 && p1 <= 2100 && p2 >= 1 && p2 <= 12 && p3 >= 1 && p3 <= 31) {
      return new Date(p1, p2 - 1, p3)
    }
  }

  const m8br = s.match(/^(\d{2})(\d{2})(\d{4})$/)
  if (m8br) {
    const d = Number(m8br[1])
    const mo = Number(m8br[2])
    const y = Number(m8br[3])
    if (y >= 1900 && y <= 2100 && mo >= 1 && mo <= 12 && d >= 1 && d <= 31) {
      return new Date(y, mo - 1, d)
    }
  }

  // 2. Formato YYYY-MM-DD
  const mIso = s.match(/^(\d{4})[-_.](\d{2})[-_.](\d{2})/)
  if (mIso) {
    return new Date(Number(mIso[1]), Number(mIso[2]) - 1, Number(mIso[3]))
  }

  // 3. Formato DD/MM/YYYY
  const mBr = s.match(/^(\d{2})[-/.](\d{2})[-/.](\d{4})/)
  if (mBr) {
    return new Date(Number(mBr[3]), Number(mBr[2]) - 1, Number(mBr[1]))
  }

  const parsed = new Date(s)
  if (isNaN(parsed.getTime())) return null
  return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate())
}

function dateKey(d: Date) {
  return `${d.getFullYear().toString().padStart(4, '0')}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`
}

function daysInMonth(monthIndex: number, year: number) {
  return new Date(year, monthIndex + 1, 0).getDate()
}

function HeaderContentGestor() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [files, setFiles] = useState<any[]>([])
  const [estoqueList, setEstoqueList] = useState<any[]>([])
  const [estoqueMesList, setEstoqueMesList] = useState<any[]>([])
  const [distribuidores, setDistribuidores] = useState<
    { id: string; name?: string; fantasy_name?: string; cnpj?: string }[]
  >([])
  const [justificativas, setJustificativas] = useState<
    { dist_id?: string | number; dist?: { id?: string | number }; dt_referencia: string }[]
  >([])
  const { month: selectedMonthRaw, year: selectedYearRaw } = useMonthFilter()

  // normaliza mês (aceita 0..11 ou 1..12)
  const monthIndex = (() => {
    const m = Number(selectedMonthRaw)
    if (isNaN(m)) return new Date().getMonth()
    return m > 11 ? m - 1 : m
  })()
  const year = Number(selectedYearRaw) || new Date().getFullYear()

  // files filtered by selected month/year
  const filteredFiles = useMemo(() => {
    return files.filter((f) => {
      const d = toLocalDate(f.envio || f.created_at || f.dt_envio)
      return d && d.getMonth() === monthIndex && d.getFullYear() === year
    })
  }, [files, monthIndex, year])

  const filteredEstoque = useMemo(() => {
    return estoqueList.filter((e) => {
      const d = toLocalDate(e.dt_ref || e.created_at)
      return d && d.getMonth() === monthIndex && d.getFullYear() === year
    })
  }, [estoqueList, monthIndex, year])

  const filteredEstoqueMes = useMemo(() => {
    return estoqueMesList.filter((em) => {
      return Number(em.mes) === monthIndex + 1 && Number(em.ano) === year
    })
  }, [estoqueMesList, monthIndex, year])

  useEffect(() => {
    async function fetchEstoque() {
      setLoading(true)
      try {
        const allDists = await carregarDistribuidores().catch(() => [])

        const distId = allDists[0]?.id
        if (distId) {
          const [resFiles, resJust, resEst, resEstMes] = await Promise.all([
            api.get(`/files/dist/${distId}`).catch(() => ({ data: [] })),
            api.get(`/j/dist/${distId}`).catch(() => ({ data: [] })),
            api.get(`/estoque/dist/${distId}`).catch(() => ({ data: [] })),
            api.get('/estoque/mensal').catch(() => ({ data: [] })),
          ])

          const filesData = resFiles?.data?.data ?? resFiles?.data ?? []
          const justData = resJust?.data?.data ?? resJust?.data ?? []
          const estData = Array.isArray(resEst.data) ? resEst.data : []
          const estMesData = Array.isArray(resEstMes.data) ? resEstMes.data : []

          setFiles(Array.isArray(filesData) ? filesData : [])
          setJustificativas(Array.isArray(justData) ? justData : [])
          setEstoqueList(estData)
          setEstoqueMesList(estMesData)

          // Filtra os distribuidores: se status for 0, só entra se tiver arquivo ou estoque no mês
          const currentFiles = (Array.isArray(filesData) ? filesData : []).filter((f: any) => {
            const d = toLocalDate(f.envio || f.created_at || f.dt_envio)
            return d && d.getMonth() === monthIndex && d.getFullYear() === year
          })

          const filteredDists = allDists.filter((item: any) => {
            if (item.status !== '0') return true
            const hasF = currentFiles.some((fi: any) => {
              const fDistId = fi.dist_id ?? fi.dist?.id ?? null
              return String(fDistId) === String(item.id)
            })
            const hasE = estData.some((e: any) => {
              const d = toLocalDate(e.dt_ref || e.created_at)
              return d && d.getMonth() === monthIndex && d.getFullYear() === year && String(e.dist_id) === String(item.id)
            })
            const hasEM = estMesData.some((em: any) => Number(em.mes) === monthIndex + 1 && Number(em.ano) === year && String(em.dist_id) === String(item.id))
            return hasF || hasE || hasEM
          })
          setDistribuidores(filteredDists)
        } else {
          setFiles([])
          setEstoqueList([])
          setEstoqueMesList([])
          setDistribuidores([])
          setJustificativas([])
        }
      } catch (error) {
        setFiles([])
        setEstoqueList([])
        setEstoqueMesList([])
        setDistribuidores([])
        setJustificativas([])
      } finally {
        setLoading(false)
      }
    }
    fetchEstoque()
  }, [monthIndex, year, navigate])

  const ensureArray = (maybe: any) => {
    if (Array.isArray(maybe)) return maybe
    if (maybe == null) return []
    return [maybe]
  }

  const distribuidorAtual = distribuidores[0]

  // build keys: allMonthKeys = all days for rendering; countMonthKeys = days to include in calculation (exclui DOMINGOS)
  const totalDays = daysInMonth(monthIndex, year)
  const allMonthKeys: string[] = []
  const countMonthKeys: string[] = [] // will exclude Sundays
  for (let d = 1; d <= totalDays; d++) {
    const dt = new Date(year, monthIndex, d)
    const key = dateKey(dt)
    allMonthKeys.push(key)
    const isSunday = dt.getDay() === 0 // 0 = Sunday
    if (!isSunday) countMonthKeys.push(key)
  }

  // sets of distinct days with file/just/estoque (for the distribuidor)
  const fileDaysSet = new Set<string>()
  const justDaysSet = new Set<string>()

  // build filesByDay for distribuidor to compute per-day estoque/sellout
  const filesByDay: Record<string, string[]> = {}

  if (distribuidorAtual) {
    const distIdStr = String(distribuidorAtual.id)

    // iterate filteredFiles and group by day for distribuidor
    filteredFiles.forEach((f) => {
      const fAny = f as any
      const fDistId = fAny.dist_id ?? fAny.dist?.id ?? null
      if (fDistId == null) return
      if (String(fDistId) !== distIdStr) return
      const d = toLocalDate(fAny.envio || fAny.created_at || fAny.dt_envio)
      if (!d) return
      const key = dateKey(d)
      fileDaysSet.add(key)
      if (!filesByDay[key]) filesByDay[key] = []
      const nm = (fAny.nm_file || fAny.originalname || fAny.filename || '').toString()
      filesByDay[key].push(nm)
    })

    // calcula o dia máximo de estoque para cobrir os dias anteriores (1 até maxEstDay)
    let maxEstDay = 0
    filteredFiles.forEach((f) => {
      const fAny = f as any
      const fDistId = fAny.dist_id ?? fAny.dist?.id ?? null
      if (String(fDistId) !== distIdStr) return
      const nm = String(fAny.nm_file || '').toLowerCase()
      if (nm.includes('estoque') || nm.includes('esto') || nm.startsWith('est')) {
        const d = toLocalDate(fAny.envio || fAny.created_at || fAny.dt_envio)
        if (d && d.getMonth() === monthIndex && d.getFullYear() === year && d.getDate() > maxEstDay) {
          maxEstDay = d.getDate()
        }
      }
    })
    filteredEstoque.forEach((e) => {
      if (String(e.dist_id) !== distIdStr) return
      const d = toLocalDate(e.dt_ref || e.created_at)
      if (d && d.getMonth() === monthIndex && d.getFullYear() === year && d.getDate() > maxEstDay) {
        maxEstDay = d.getDate()
      }
    })

    const hoje = new Date()
    const isCurrentMonth =
      monthIndex === hoje.getMonth() && year === hoje.getFullYear()
    const isFutureMonth =
      year > hoje.getFullYear() ||
      (year === hoje.getFullYear() && monthIndex > hoje.getMonth())

    if (isFutureMonth) {
      maxEstDay = 0
    } else if (isCurrentMonth) {
      maxEstDay = Math.min(maxEstDay, hoje.getDate())
    }

    if (maxEstDay > 0) {
      for (let d = 1; d <= maxEstDay; d++) {
        const dt = new Date(year, monthIndex, d)
        fileDaysSet.add(dateKey(dt))
      }
    }

    // justificativas grouping -> justDaysSet
    justificativas.forEach((j) => {
      const jAny = j as any
      const jDistId = jAny.dist_id ?? jAny.dist?.id ?? null
      if (jDistId == null) return
      if (String(jDistId) !== distIdStr) return
      const d = toLocalDate(jAny.dt_referencia)
      if (!d) return
      justDaysSet.add(dateKey(d))
    })
  }

  // union for combined coverage
  const combinedDaysSet = new Set<string>([...Array.from(fileDaysSet), ...Array.from(justDaysSet)])

  // justificadosCount and comAtraso use countMonthKeys (domingos excluídos)
  const justificadosCount = countMonthKeys.filter((k) => justDaysSet.has(k)).length
  const comAtraso = countMonthKeys.filter((k) => !combinedDaysSet.has(k)).length

  // semSellout: counts days where:
  // - there is at least one file or db entry with 'estoque' for that day
  // - AND there are NO files with 'sellout' in the filename for that same day
  const semSelloutDays: string[] = []
  for (const k of countMonthKeys) {
    const filesForDay = filesByDay[k] ?? []
    const lower = filesForDay.map((f) => (f || '').toString().toLowerCase())
    const hasEstoque = lower.some((s) => s.includes('estoque') || s.includes('esto') || s.startsWith('est'))
    const hasSellout = lower.some((s) => s.includes('sellout') || s.includes('venda') || s.includes('vendas'))
    if (hasEstoque && !hasSellout) semSelloutDays.push(k)
  }
  const semSelloutCount = semSelloutDays.length

  // arquivos do mês para o distribuidor atual
  const arquivosDoMesVigente = filteredFiles.filter((f) => {
    const fAny = f as any
    const fDistId = fAny.dist_id ?? fAny.dist?.id ?? null
    if (!distribuidorAtual) return false
    return String(fDistId) === String(distribuidorAtual.id)
  })
  const enviados = arquivosDoMesVigente.length
  const recebidos = enviados

  const iconsC = [
    {
      id: 0,
      src: <IoCloseCircle />,
      alt: 'Painel Geral',
      label: 'Dias em Atraso',
      dist: `${comAtraso} dias`,
      status: 'warn',
      class: 'warn-label',
    },
    {
      id: 1,
      src: <IoWarning />,
      alt: 'Regularidade',
      label: 'Estoque Enviado Sem Vendas ',
      dist: `${semSelloutCount} dias`,
      status: 'alert',
      class: 'alert-label',
    },
    {
      id: 2,
      src: <MdOutlinePendingActions />,
      alt: 'Produtos',
      label: 'Dias Justificados',
      dist: `${justificadosCount} dias`,
      status: 'check',
      class: 'check-label',
    },
    {
      id: 3,
      src: <FaFileCircleCheck />,
      alt: 'Produtos',
      label: 'Arquivos Recebidos',
      dist: `${recebidos} arquivos`,
      status: 'check-green',
      class: 'check-green-label',
    },
  ]

  return (
    <>
      <MainHeader>
        {iconsC.map((item) => (
          <ContentHeader key={item.id}>
            <div className='content'>
              <label className={item.class}>{item.src}</label>
              <div>
                <label className={item.status}>{item.label}</label>
                <p className={item.status}>{item.dist}</p>
              </div>
            </div>
          </ContentHeader>
        ))}
      </MainHeader>
    </>
  )
}

export default HeaderContentGestor
